export const HEADER_HEIGHT = '70px'; // assuming a 60px default logo
export const SKIP_FADE_IN_FOR_THE_FIRST_N_IDEALISTS = 2; // on new search input, we don't want the fade in to happen every time; we just want in on scroll
export const SKIP_FADE_IN_FOR_THE_FIRST_N_FEED_ITEMS = 6; // we have polling here; we don't want a fade in every X seconds, that's why it's a bit increased
